export const PendingChangesSaveSummaryTestIds = {
  RECALCULATED_TOGGLE: 'pending-changes-save-summary.recalculated-toggle',
  RECALCULATED_LIST: 'pending-changes-save-summary.recalculated-list',
  getAutomaticFeeChangeId: key => `pending-changes-save-summary.automatic-fee-change-${key}`,
};
